import { THttpRequestConfig, THttpRequestParams } from 'hooks';
import { IAdSectionBidCreatePayload, IAdSectionBidEditPayload } from 'types/adManagement';

export const AD_MANAGEMENT_API = {
	adSectionList: (vendorId: number, name?: string, params?: THttpRequestParams): THttpRequestConfig => ({
		url: `/vendor/vendors/${vendorId}/ads/biddable`,
		method: 'GET',
		params: {
			name,
			...params,
		},
	}),

	getCompetitorsInfo: (vendorId: number, adSectionId: number): THttpRequestConfig => ({
		url: `/vendor/vendors/${vendorId}/ads/${adSectionId}/metrics`,
		method: 'GET',
	}),

	AD_BIDS: {
		list: (vendorId: number, name?: string, params?: THttpRequestParams): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids`,
			method: 'GET',
			params: {
				name,
				...params,
			},
		}),
		create: (vendorId: number, data: IAdSectionBidCreatePayload): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids`,
			method: 'POST',
			data,
		}),

		get: (vendorId: number, adBidId: number): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids/${adBidId}`,
			method: 'GET',
		}),

		update: (vendorId: number, adBidId: number, data: Partial<IAdSectionBidEditPayload>): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids/${adBidId}`,
			method: 'PATCH',
			data,
		}),

		// ACTIONS
		resume: (vendorId: number, addBidId: number): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids/${addBidId}/resume`,
			method: 'POST',
		}),
		pause: (vendorId: number, addBidId: number): THttpRequestConfig => ({
			url: `/vendor/vendors/${vendorId}/ad-bids/${addBidId}/pause`,
			method: 'POST',
		}),
		cancel: (vendorId: number, addBidId: number): THttpRequestConfig => ({
			url: `vendor/vendors/${vendorId}/ad-bids/${addBidId}/cancel`,
			method: 'POST',
		}),
	},
};
